var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('Link',{staticClass:"link",class:_vm.classname,attrs:{"post_link":_vm.link}},[_vm._t("default")],2):_c('span',{staticClass:"no-link",class:_vm.classname},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }